import { getContext, setContext } from 'svelte';
import { DEFAULT_UI_I18N, type UiI18n } from './i18n.js';

const UI_I18N_KEY = Symbol.for('@ui-i18n');

export function setUiI18n(i18n: UiI18n): void {
	setContext(UI_I18N_KEY, i18n);
}

export function getUiI18n(): UiI18n {
	return getContext<UiI18n>(UI_I18N_KEY) ?? DEFAULT_UI_I18N;
}
